<div class="task-list-page">
  <div class="top-section">
    <div class="task-list-page-header-line">
      <div class="header-text">
        <h1>
          {{ pageTitle }}
        </h1>
      </div>

      <div class="button-div">
        <button mat-icon-button aria-label="Filter" (click)="toggleFilter()">
          <mat-icon>filter_alt</mat-icon>
        </button>
        <button mat-icon-button aria-label="Search" (click)="openSearch()">
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </div>
    <app-filter-task-buttons *ngIf="showFilter"></app-filter-task-buttons>
  </div>
  <div class="bottom-section">
    <div #listContainer class="list-container">
      <app-task-list
        [orgId]="orgId"
        [spaceId]="spaceId"
        [listId]="listId"
        [listFilter]="listFilter"
        [headerText]="listHeaderText"
        [selectFirstInListTaskPathBase]="selectFirstInListTaskPathBase"
        class="list-padding"
        [preventDragAndEdit]="preventDragAndEdit"
      ></app-task-list>
    </div>
    <app-task-detail
      *ngIf="selectDisplayTaskId"
      [orgId]="orgId"
      [spaceId]="spaceId"
      [taskId]="selectDisplayTaskId"
      class="theme-background-color large-element-rounding desktop-visible"
    ></app-task-detail>
  </div>
</div>
